var _path, _path2, _path3, _path4, _path5, _path6, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFile({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 30,
    viewBox: "0 0 25 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 0L25 10V26.5C25 28.433 23.433 30 21.5 30H3.5C1.567 30 0 28.433 0 26.5V3.5C0 1.567 1.567 0 3.5 0H15Z",
    fill: "url(#paint0_linear_2296_38764)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25 10H18.6768C16.7438 10 15 8.25622 15 6.32322V0L25 10Z",
    fill: "white",
    fillOpacity: 0.4
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.123 25.0909C15.7025 25.0909 15.3398 24.9981 15.0349 24.8125C14.7319 24.625 14.498 24.3636 14.3332 24.0284C14.1703 23.6913 14.0889 23.2992 14.0889 22.8523C14.0889 22.4053 14.1703 22.0114 14.3332 21.6705C14.498 21.3277 14.7271 21.0606 15.0207 20.8693C15.3161 20.6761 15.6608 20.5795 16.0548 20.5795C16.282 20.5795 16.5065 20.6174 16.7281 20.6932C16.9497 20.7689 17.1514 20.892 17.3332 21.0625C17.515 21.2311 17.6599 21.4545 17.7678 21.733C17.8758 22.0114 17.9298 22.3542 17.9298 22.7614V23.0455H14.5661V22.4659H17.248C17.248 22.2197 17.1987 22 17.1002 21.8068C17.0036 21.6136 16.8654 21.4612 16.6855 21.3494C16.5074 21.2377 16.2972 21.1818 16.0548 21.1818C15.7877 21.1818 15.5567 21.2481 15.3616 21.3807C15.1684 21.5114 15.0197 21.6818 14.9156 21.892C14.8114 22.1023 14.7593 22.3277 14.7593 22.5682V22.9545C14.7593 23.2841 14.8161 23.5634 14.9298 23.7926C15.0453 24.0199 15.2053 24.1932 15.4099 24.3125C15.6144 24.4299 15.8521 24.4886 16.123 24.4886C16.2991 24.4886 16.4582 24.464 16.6002 24.4148C16.7442 24.3636 16.8682 24.2879 16.9724 24.1875C17.0766 24.0852 17.157 23.9583 17.2139 23.8068L17.8616 23.9886C17.7934 24.2083 17.6788 24.4015 17.5178 24.5682C17.3569 24.733 17.158 24.8617 16.9213 24.9545C16.6845 25.0455 16.4184 25.0909 16.123 25.0909Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0654 19.1818V25H12.3949V19.1818H13.0654Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4965 25V20.6364H11.1669V25H10.4965ZM10.8374 19.9091C10.7067 19.9091 10.594 19.8646 10.4993 19.7756C10.4065 19.6866 10.3601 19.5795 10.3601 19.4545C10.3601 19.3295 10.4065 19.2225 10.4993 19.1335C10.594 19.0445 10.7067 19 10.8374 19C10.9681 19 11.0798 19.0445 11.1726 19.1335C11.2673 19.2225 11.3147 19.3295 11.3147 19.4545C11.3147 19.5795 11.2673 19.6866 11.1726 19.7756C11.0798 19.8646 10.9681 19.9091 10.8374 19.9091Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.55686 20.6364V21.2045H7.20459V20.6364H9.55686ZM7.90914 25V20.0341C7.90914 19.7841 7.96785 19.5758 8.08527 19.4091C8.2027 19.2424 8.35516 19.1174 8.54266 19.0341C8.73016 18.9508 8.92807 18.9091 9.13641 18.9091C9.30118 18.9091 9.43565 18.9223 9.53982 18.9489C9.64398 18.9754 9.72164 19 9.77277 19.0227L9.57959 19.6023C9.5455 19.5909 9.49815 19.5767 9.43754 19.5597C9.37883 19.5426 9.30118 19.5341 9.20459 19.5341C8.983 19.5341 8.82296 19.59 8.72448 19.7017C8.62789 19.8134 8.57959 19.9773 8.57959 20.1932V25H7.90914Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2296_38764",
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 30,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D0D8E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BAC3CD"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFile);
export default __webpack_public_path__ + "static/media/file.5ba406a064cc051f0879a04bb50100ca.svg";
export { ForwardRef as ReactComponent };